module.exports = __webpack_public_path__ + "img/natgeothumb.7f7e4226.gif";